export default {
  props: {
    redirectBrands: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    createBackUrl () {
      if (this.redirectBrands) {
        return { name: 'brands' }
      } else {
        return { name: 'competitions' }
      }
    }
  }
}
